export const MeetingWSChannels = {
  public: '/meeting/:eventId',
  private: '/user/meeting/:eventId',
} as const;

export const MeetingWSMessages = {
  EventStarted: 'event_started',
  MeetingEnded: 'meeting_ended',
  GuestExitedMeeting: 'guest_exited_meeting',
  GuestHandUp: 'guest_hand_up',
  GuestHandDown: 'guest_hand_down',
  GuestHandLoweredBy: 'guest_hand_lowered_by',
  BigMeetingModeEnabled: 'big_meeting_mode_enabled',
  AudienceCountUpdated: 'audience_count_updated',
  EventMetricsUpdated: 'event_metrics_updated',
  BmmGuestHandUp: 'bmm_guest_hand_up',
  BmmGuestHandDown: 'bmm_guest_hand_down',
  BmmGuestHandUpList: 'bmm_guest_hand_up_list',
  UserMuted: 'guest_muted',
  QuestionAssignment: 'question_assignment',
  Snapshot: 'snapshot',
} as const;

export type MeetingWSMessage = (typeof MeetingWSMessages)[keyof typeof MeetingWSMessages];

export const isMeetingWSMessage = (message: string): message is MeetingWSMessage =>
  Object.values(MeetingWSMessages).includes(message as MeetingWSMessage);

export const MeetingWSPath = '/meeting/v2/:eventId' as const;

export const MeetingWSActions = {
  RaiseHand: `${MeetingWSPath}/raise_hand`,
  LowerHand: `${MeetingWSPath}/lower_hand`,
  LowerOtherUserHand: `${MeetingWSPath}/lower_hand/:userId`,
  Join: `${MeetingWSPath}/join`,
  JoinNattering: `${MeetingWSPath}/join_nattering`,
  SkipNattering: `${MeetingWSPath}/skip_nattering`,
  MuteUser: `${MeetingWSPath}/mute_guest`,
  /** Automated Natters only */
  Leave: `${MeetingWSPath}/leave`,
} as const;

export type MeetingWSAction = (typeof MeetingWSActions)[keyof typeof MeetingWSActions];

export const isMeetingWSAction = (action: string): action is MeetingWSAction =>
  Object.values(MeetingWSActions).includes(action as MeetingWSAction);
